import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from 'shared/hooks';

/**
 * @param {Object} props
 * @param {string} [props.color] - Icon color; defaults to inheriting from the nav.
 * @param {'small'|'medium'|'large'} [props.size]
 */
// Single-click light/dark switch. Lives in the nav bar on desktop and mobile.
export default function ThemeModeToggle({ color = 'inherit', size = 'medium' }) {
  const { resolvedMode, toggleMode } = useThemeMode();
  const isDark = resolvedMode === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        onClick={toggleMode}
        size={size}
        sx={{ color, flexShrink: 0 }}
      >
        {isDark ? <LightModeIcon fontSize={size} /> : <DarkModeIcon fontSize={size} />}
      </IconButton>
    </Tooltip>
  );
}
